<template>
	<section id="plans" class="plans">
		<div class="container inner">
			<div class="head">
				<div class="section-head">
					<span class="label">Plans</span>
					<h2 class="cap section-title">Membership</h2>
				</div>
				<div class="tabs" role="group" aria-label="Plan type">
					<button
						v-for="plan in plans"
						:key="plan.id"
						type="button"
						class="tab"
						:aria-pressed="active === plan.id"
						@click="active = plan.id"
					>
						{{ plan.label }}
					</button>
				</div>
			</div>

			<div class="prices">
				<article v-for="option in current.options" :key="option.period" :class="['price', { best: option.best }]">
					<span class="mono period">{{ option.period }}</span>
					<span class="cap amount">€{{ format(option.price) }}</span>
					<span class="note">{{ option.best ? "Best value" : "Paid at checkout" }}</span>
					<a
						v-if="option.url"
						:href="option.url"
						class="btn signup"
						target="_blank"
						rel="noopener"
					>
						Sign up
						<span class="visually-hidden">for {{ current.label }}, {{ option.period }} (opens checkout)</span>
					</a>
					<span v-else class="btn signup disabled" aria-disabled="true">Coming soon</span>
				</article>
			</div>

			<p class="mono small">
				+ €30 annual insurance · +2.5% handling fee at checkout · non-refundable · private classes on
				request
			</p>
		</div>
	</section>
</template>

<script>
import { plans } from "../../data/site.js";

export default {
	data() {
		return { plans, active: plans[0].id };
	},
	computed: {
		current() {
			return this.plans.find((plan) => plan.id === this.active);
		},
	},
	methods: {
		format(value) {
			return value.toLocaleString("en-US");
		},
	},
};
</script>

<style scoped>
.plans {
	background: var(--white);
	border-top: 1px solid var(--line);
	border-bottom: 1px solid var(--line);
}

.inner {
	padding-top: 80px;
	padding-bottom: 80px;
	display: flex;
	flex-direction: column;
	gap: 32px;
}

.head {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: flex-end;
	gap: 20px;
}

.tabs {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.tab {
	min-height: 44px;
	padding: 0 18px;
	border: 1px solid var(--line-strong);
	border-radius: 999px;
	background: var(--white);
	color: var(--ink);
	font: 600 14px var(--body);
	white-space: nowrap;
	cursor: pointer;
}

.tab[aria-pressed="true"] {
	border-color: var(--ink);
	background: var(--ink);
	color: var(--white);
}

.prices {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 12px;
}

.price {
	min-height: 240px;
	padding: 24px;
	display: flex;
	flex-direction: column;
	gap: 12px;
	border: 1px solid var(--line);
	border-radius: var(--radius);
	background: var(--ground);
}

.price.best {
	border-color: var(--mat);
	background: var(--mat);
}

.period {
	font-size: 13px;
}

.amount {
	font-size: 56px;
	line-height: 1;
}

.note {
	font-size: 14px;
}

.signup {
	margin-top: auto;
	width: 100%;
}

.best .signup:hover {
	background: var(--white);
	border-color: var(--white);
	color: var(--ink);
}

.signup.disabled {
	opacity: 0.5;
	cursor: default;
}

.small {
	font-size: 13px;
	color: var(--muted);
}

@media (max-width: 768px) {
	.inner {
		padding-top: 48px;
		padding-bottom: 48px;
		gap: 16px;
	}

	.head {
		flex-direction: column;
		align-items: stretch;
		gap: 16px;
		width: 100%;
		min-width: 0;
	}

	.tabs {
		width: calc(100% + 32px);
		min-width: 0;
		flex-wrap: nowrap;
		overflow-x: auto;
		margin: 0 -16px;
		padding: 0 16px 4px;
	}

	.tab {
		flex-shrink: 0;
	}

	.prices {
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 10px;
	}

	.price {
		min-height: 0;
		padding: 16px;
		gap: 8px;
		border-radius: 14px;
	}

	.amount {
		font-size: 40px;
	}

	.note {
		font-size: 13px;
	}

	.signup {
		min-height: 44px;
		padding: 0 12px;
		font-size: 15px;
	}

	.small {
		font-size: 12px;
	}
}
</style>
